export const FEEDBACK_TITLE = "discard.listing.toast.title";
export const FEEDBACK_DESCRIPTION = "discard.listing.toast.text";
